module.exports = __webpack_public_path__ + "img/MOBILE-VTA-VALORACION-AGENDADA.d55e2e03.png";